// ActivarCuenta.jsx — destino del magic link: el usuario crea su contraseña
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../api/axios";
import "./Premium.css";

export default function ActivarCuenta() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const linkValido = email && token;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/account/activate", {
        email,
        token,
        password,
        password_confirmation: confirm,
      });
      if (data?.token) {
        localStorage.setItem("token", data.token);
      }
      setDone(true);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "No se pudo activar la cuenta. El enlace puede haber caducado."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Activa tu cuenta · Wayo</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Header />

      <main className="premium-web">
        <section className="premium-web-hero">
          <div className="premium-web-card">
            {done ? (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 56, marginBottom: 8 }}>✅</div>
                <h1 className="premium-web-title" style={{ fontSize: 26 }}>
                  ¡Cuenta activada!
                </h1>
                <p className="premium-web-subtitle">
                  Ya puedes iniciar sesión en la app de Wayo con tu email y tu
                  nueva contraseña.
                </p>
                <a
                  className="premium-web-cta"
                  style={{ display: "inline-block", textDecoration: "none", textAlign: "center" }}
                  href="https://wayoai.app/download"
                >
                  Abrir la app
                </a>
              </div>
            ) : !linkValido ? (
              <p className="premium-web-error" style={{ textAlign: "center" }}>
                Enlace de activación no válido. Abre el enlace desde el email que
                te enviamos.
              </p>
            ) : (
              <>
                <h1 className="premium-web-title" style={{ fontSize: 26, textAlign: "center" }}>
                  Crea tu contraseña
                </h1>
                <p className="premium-web-subtitle" style={{ marginBottom: 22 }}>
                  Activa la cuenta de <strong>{email}</strong> para empezar a usar
                  Wayo Premium.
                </p>

                <form onSubmit={handleSubmit}>
                  <input
                    type="password"
                    className="premium-web-input"
                    placeholder="Contraseña (mín. 6 caracteres)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                  />
                  <input
                    type="password"
                    className="premium-web-input"
                    placeholder="Repite la contraseña"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    autoComplete="new-password"
                  />

                  <button className="premium-web-cta" type="submit" disabled={loading}>
                    {loading ? "Activando…" : "Activar mi cuenta"}
                  </button>
                </form>

                {error && <p className="premium-web-error">{error}</p>}
              </>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
